export const urls = {
  GET_MASINE: 'KlijentMasine/vrati_klijent_masine_za_id_kupca',
  INSERT_MASINE: 'KlijentMasine/unos_klijent_masine',
  UPDATE_MASINE: 'KlijentMasine/izmena_klijent_masine',
  DELETE_MASINE: 'KlijentMasine/brisanje_klijent_masine',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
  GET_DOKUMENTA: 'Dokumenta/vrati_dokumenta_objekta',
  DOWNLOAD_DOKUMENT:
    'Dokumenta/konvertovanje_base64_sa_id_dokumenta_servisnog_zahteva',
};
